<template>
  <div class="all-catalog-pager">
    <ul class="list">
      <li
        class="list-item list-item--nav list-item--nav-left"
        :class="{'list-item--disabled': !value}"
        @click="prevPage()"
      >
        <svg class="list-icon">
          <use x="0" y="0" xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#icon-arrow"></use>
        </svg>
      </li>

      <li
        v-for="page in pagination"
        class="list-item"
        :class="{'list-item--current': page.selected, 'list-item--break': page.breakView}"
        @click="!page.breakView ? handlePageSelected(page.content) : false"
      >
        <span v-if="page.breakView">...</span>
        <a v-else :href="currentPath + '?page=' + page.index" @click.prevent>
          {{ page.content }}
        </a>
      </li>

      <li
        class="list-item list-item--nav list-item--nav-right"
        :class="{'list-item--disabled': (value + 1) === pageCount}"
        @click="nextPage()"
      >
        <svg class="list-icon">
          <use x="0" y="0" xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#icon-arrow"></use>
        </svg>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'Pagination',
  props: {
    value: {
      type: Number
    },
    pageCount: {
      type: Number,
      required: true
    },
    clickHandler: {
      type: Function,
      default: () => {}
    }
  },
  data() {
    return {
      currentPath: window.location.pathname
    }
  },
  computed: {
    pagination() {
      const items = {}
      const marginPages = 1
      const pageRange = 3
      const currentPage = this.value + 1

      if (this.pageCount <= pageRange) {
        for (let index = 0; index < this.pageCount; index++) {
          items[index] = {
            index: index,
            content: index + 1,
            selected: index === (currentPage - 1)
          }
        }
      }
      else {
        const halfPageRange = Math.floor(pageRange / 2)

        const setPageItem = (index) => {
          items[index] = {
            index: index,
            content: index + 1,
            selected: index === (currentPage - 1)
          }
        }

        const setBreakView = (index) => {
          items[index] = {
            disabled: true,
            breakView: true
          }
        }

        for (let i = 0; i < marginPages; i++) {
          setPageItem(i)
        }

        let selectedRangeLow = 0
        if (currentPage - halfPageRange > 0) {
          selectedRangeLow = currentPage - 1 - halfPageRange
        }

        let selectedRangeHigh = selectedRangeLow + pageRange - 1
        if (selectedRangeHigh >= this.pageCount) {
          selectedRangeHigh = this.pageCount - 1
          selectedRangeLow = selectedRangeHigh - pageRange + 1
        }

        for (let i = selectedRangeLow; i <= selectedRangeHigh && i <= this.pageCount - 1; i++) {
          setPageItem(i)
        }

        if (selectedRangeLow > marginPages) {
          setBreakView(selectedRangeLow - 1)
        }

        if (selectedRangeHigh + 1 < this.pageCount - marginPages) {
          setBreakView(selectedRangeHigh + 1)
        }

        for (let i = this.pageCount - 1; i >= this.pageCount - marginPages; i--) {
          setPageItem(i)
        }
      }
      return items
    },
  },
  methods: {
    handlePageSelected(selected) {
      if ((this.value + 1) === selected) {
        return
      }

      this.$emit('input', selected)
      this.clickHandler(selected)
    },
    prevPage() {
      if ((this.value + 1) <= 1) {
        return
      }

      this.handlePageSelected(this.value)
    },
    nextPage() {
      if ((this.value + 1) >= this.pageCount) {
        return
      }

      this.handlePageSelected(this.value + 2)
    }
  }
}
</script>
